// mparle-wishlist.js
// localStorage-based wishlist. Sync naar customer-metafield zit out of MVP-scope
// (zie spec sectie 17 — Customer Account Extension).
(function () {
  const KEY = 'mparle:wishlist';

  function read() {
    try {
      const raw = localStorage.getItem(KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(parsed)) return [];
      let hadLegacy = false;
      const items = parsed
        .map((entry) => {
          // Legacy: oude string-IDs zonder product-data — niet meer bruikbaar
          if (typeof entry === 'string') { hadLegacy = true; return null; }
          if (entry && typeof entry === 'object' && typeof entry.id === 'string' && entry.id.length > 0) {
            // Object zonder bruikbare data — ook weg
            if (!entry.handle || !entry.url || !entry.title) { hadLegacy = true; return null; }
            return entry;
          }
          return null;
        })
        .filter(Boolean);
      // Eenmalige cleanup: legacy-entries permanent verwijderen
      if (hadLegacy) {
        try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (_) { /* fail silently */ }
      }
      return items;
    } catch (_) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch (_) {
      /* quota of private mode — fail silently */
    }
    sync();
    render();
  }

  function has(items, id) {
    return items.some((item) => item.id === id);
  }

  function sync() {
    const items = read();
    document.querySelectorAll('[data-mp-wishlist-count]').forEach((el) => {
      el.textContent = String(items.length);
    });
    document.querySelectorAll('[data-mp-wishlist]').forEach((btn) => {
      const id = btn.dataset.mpWishlist;
      const active = has(items, id);
      btn.dataset.mpWishlistActive = active ? 'true' : 'false';
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function toast(text) {
    const el = document.createElement('div');
    el.className = 'mp-toast';
    el.setAttribute('role', 'status');
    el.textContent = text;
    document.body.appendChild(el);
    requestAnimationFrame(() => el.classList.add('is-visible'));
    setTimeout(() => {
      el.classList.remove('is-visible');
      setTimeout(() => el.remove(), 300);
    }, 4500);
  }

  function readBtnData(btn) {
    const id = btn.dataset.mpWishlist;
    if (!id) return null;
    return {
      id: id,
      handle: btn.dataset.mpWishlistHandle || '',
      title: btn.dataset.mpWishlistTitle || '',
      image: btn.dataset.mpWishlistImage || '',
      url: btn.dataset.mpWishlistUrl || '',
      price: btn.dataset.mpWishlistPrice || '',
      compareAt: btn.dataset.mpWishlistCompare || '',
    };
  }

  function toggle(btn) {
    const data = readBtnData(btn);
    if (!data) return;
    const items = read();
    const idx = items.findIndex((item) => item.id === data.id);
    const wasEmpty = items.length === 0;
    if (idx >= 0) {
      items.splice(idx, 1);
    } else {
      items.push(data);
      if (wasEmpty && !window.mpCustomerLoggedIn) {
        toast('Maak een account aan om je wishlist te bewaren →');
      }
    }
    write(items);
  }

  function removeById(id) {
    const items = read().filter((item) => item.id !== id);
    write(items);
  }

  function el(tag, attrs, children) {
    const node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach((key) => {
        if (key === 'class') node.className = attrs[key];
        else if (key === 'text') node.textContent = attrs[key];
        else node.setAttribute(key, attrs[key]);
      });
    }
    if (children) children.forEach((c) => c && node.appendChild(c));
    return node;
  }

  function buildItem(item) {
    const media = el('a', { class: 'mp-wl__media', href: item.url, 'aria-label': item.title });
    if (item.image) {
      media.appendChild(el('img', { class: 'mp-wl__img', src: item.image, alt: item.title, loading: 'lazy' }));
    } else {
      media.appendChild(el('div', { class: 'mp-wl__img mp-wl__img--placeholder', 'aria-hidden': 'true' }));
    }

    const nameLink = el('a', { href: item.url, text: item.title });
    const name = el('h3', { class: 'mp-wl__name' }, [nameLink]);

    const body = el('div', { class: 'mp-wl__body' }, [name]);

    if (item.price) {
      const price = el('div', { class: 'mp-wl__price' });
      if (item.compareAt && item.compareAt !== item.price) {
        price.appendChild(el('span', { class: 'mp-wl__price-sale', text: item.price }));
        price.appendChild(document.createTextNode(' '));
        price.appendChild(el('s', { class: 'mp-wl__price-old', text: item.compareAt }));
      } else {
        price.appendChild(el('span', { text: item.price }));
      }
      body.appendChild(price);
    }

    const removeBtn = el('button', {
      type: 'button',
      class: 'mp-wl__remove',
      'data-mp-wishlist-remove': item.id,
      'aria-label': 'Verwijder uit wishlist',
    });
    removeBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

    return el('article', { class: 'mp-wl__item', 'data-mp-wishlist-item': item.id }, [media, body, removeBtn]);
  }

  function render() {
    const grids = document.querySelectorAll('[data-mp-wishlist-grid]');
    if (grids.length === 0) return;
    const emptyEls = document.querySelectorAll('[data-mp-wishlist-empty]');
    const items = read();
    const renderable = items.filter((item) => item.handle && item.url && item.title);

    grids.forEach((grid) => { grid.textContent = ''; });
    if (renderable.length === 0) {
      grids.forEach((grid) => { grid.hidden = true; });
      emptyEls.forEach((el) => { el.hidden = false; });
      return;
    }
    emptyEls.forEach((el) => { el.hidden = true; });
    grids.forEach((grid) => {
      grid.hidden = false;
      renderable.forEach((item) => grid.appendChild(buildItem(item)));
    });
  }

  document.addEventListener('click', (e) => {
    const removeBtn = e.target.closest('[data-mp-wishlist-remove]');
    if (removeBtn) {
      e.preventDefault();
      removeById(removeBtn.dataset.mpWishlistRemove);
      return;
    }
    const btn = e.target.closest('[data-mp-wishlist]');
    if (!btn) return;
    e.preventDefault();
    toggle(btn);
  });

  // Wishlist-link in header → standalone wishlist-pagina (geen login nodig — localStorage-based)
  document.querySelectorAll('[data-mp-wishlist-link]').forEach((link) => {
    link.setAttribute('href', '/pages/wishlist');
  });

  sync();
  render();
})();
